const SITES = [
	{id:'studioBuds',title: 'Global_ProductSelector_Product1', path: 'beats-studio-buds'},
	{id:'fitPro',title: 'Global_ProductSelector_Product2', path: 'beats-flex-pro'}
];

export default SITES;